import { render, staticRenderFns } from "./GoToNotification.vue?vue&type=template&id=6ef40e45"
import script from "./GoToNotification.vue?vue&type=script&lang=js"
export * from "./GoToNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports